import { createSlice } from '@reduxjs/toolkit';
// import { HYDRATE } from 'next-redux-wrapper';

const initialState = {
  slug: '',
  following: false,
  offeringData: {},
  showInvestNow: true,
  stickyClass: false,
};

export const offeringSlice = createSlice({
  name: 'offering',
  initialState,
  reducers: {
    updateOfferingField: {
      reducer: (state, action) => {
        state[action.payload.key] = action.payload.value;
      },
    },
    setPageSlug: {
      reducer: (state, action) => {
        state.slug = action.payload.value;
      },
    },
    clear: () => ({
      ...initialState,
    }),
  },
  // extraReducers: (builder) => {
  //   builder.addCase(HYDRATE, (state, action) => ({
  //     ...state,
  //     ...action.payload.offering,
  //   }));
  // },
});

export const { setPageSlug, updateOfferingField } = offeringSlice.actions;

export default offeringSlice.reducer;
